export type FormValidationErrors = {
    formHasErrors: boolean,
    errors: ValidationError[]
}

export type ValidationError = {
    type: ValidationErrorType
    property: string,
    parent: string | undefined,
    error: string
}

export enum ValidationErrorType {
    REQUIRED_FIELDS,
    INVALID_CHARACTERS,
    DUPLICATE_FIELDS
}